import {getAuthorizationHeader, getTokenFromCookies} from '@/api/common-utils';
import {BaseApi} from '@/api/base-api';

interface DiagonalGrowthWebsitesListProps {
  pageNumber: number;
  pageSize: number;
}

interface DiagonalGrowthWebsiteDetailProps {
  id: string;
  periodStart: string;
  periodEnd: string;
}

class DiagonalGrowthApi extends BaseApi {
  private static readonly baseUrl: string = 'https://api.diagonalgrowth.com';
  private static readonly keywordBaseUrl: string = 'https://keyword.searchatlas.com/api/';
  private static readonly superApiKey: string = 'api_key_2d45c27a223a67422a430w463259aa38b32dghes9ebff6';

  public async getDiagonalGrowthWebsites({pageNumber, pageSize}: DiagonalGrowthWebsitesListProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/webiste/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      params: {
        page: pageNumber,
        page_size: pageSize,
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }
  public async getDiagonalGrowthWebsite({id, periodStart, periodEnd}: DiagonalGrowthWebsiteDetailProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/webiste/${id}/keyword-details/?period_start=${periodStart}&period_end=${periodEnd}`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }
  public async createDiagonalGrowthWebsiteCampaign(payload) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/webiste/`, payload, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }
  public async createDiagonalGrowthGmbCampaign(payload) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/`, payload, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }
  public async createReferralCampaign(payload) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/`, payload, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }
  public async updateReferralCampaign(id, payload) {
    const response: any = await this.axios.put(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/${id}/`, payload, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }
  public async updateDiagonalGrowthWebsiteCampaign(id, payload) {
    const response: any = await this.axios.put(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/webiste/${id}/`, payload, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }

  public async updateDiagonalGrowthGmbCampaign(id, payload) {
    const response: any = await this.axios.put(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/`, payload, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }

  public async deleteDiagonalGrowthWebsiteCampaign(id) {
    const response: any = await this.axios.delete(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/webiste/${id}/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }

  public async deleteDiagonalGrowthGmbCampaign(id) {
    const response: any = await this.axios.delete(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }

  public async deleteDiagonalGrowthReferralCampaign(id) {
    const response: any = await this.axios.delete(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/${id}/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }

  public async getGoogleMyBusinessList({pageNumber, pageSize}: DiagonalGrowthWebsitesListProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      params: {
        page: pageNumber,
        page_size: pageSize,
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }

  public async getReferralTrafficList({pageNumber, pageSize}: DiagonalGrowthWebsitesListProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      params: {
        page: pageNumber,
        page_size: pageSize,
      },
      cancelToken: this.cancelToken,
    });

    return response.data;
  }

  public async getGoogleMyBusiness({id}) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }

  public async getReferralTrafficDetail({id, periodStart, periodEnd}: DiagonalGrowthWebsiteDetailProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/${id}/report/?period_start=${periodStart}&period_end=${periodEnd}`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }
  public async loadSingleReferralTrafficDetail(id) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/${id}/`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }

  public async getKeywordPositionAvg({id, periodStart, periodEnd}: DiagonalGrowthWebsiteDetailProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/keyword-position-avg/?period_start=${periodStart}&period_end=${periodEnd}`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }

  public async getKeywordPositionHistory({id, periodStart, periodEnd}: DiagonalGrowthWebsiteDetailProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/keyword-position-history/?period_start=${periodStart}&period_end=${periodEnd}`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }

  public async getKeywordDistributionChartData({id, periodStart, periodEnd}: DiagonalGrowthWebsiteDetailProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/keyword_distribution/?period_start=${periodStart}&period_end=${periodEnd}`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }

  public async getHeatMapData({id}) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.keywordBaseUrl}v2/google-business/${id}/grids/?page_size=100&super_api_key=${DiagonalGrowthApi.superApiKey}`, {
      headers: {
        Accept: 'application/json',
      },
    });

    return response.data;
  }

  public async getHeatMapDataDetail({id, gridId, date}) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.keywordBaseUrl}v2/google-business/${id}/location-report/?grid_id=${gridId}${date ? `&date=${date}` : ''}&super_api_key=${DiagonalGrowthApi.superApiKey}`, {
      headers: {
        Accept: 'application/json',
      },
    });

    return response.data;
  }

  public async getHeatMapDataLocations(value, countryName, lat, lng) {
    return `${DiagonalGrowthApi.keywordBaseUrl}v1/google-business/business-suggestions/?query=${value}&location=${countryName}&lat=${lat}&long=${lng}&super_api_key=${DiagonalGrowthApi.superApiKey}`;
  }

  public async fetchBusinessByUrl() {
    return `${DiagonalGrowthApi.keywordBaseUrl}v2/google-business/business-details/?super_api_key=${DiagonalGrowthApi.superApiKey}`;
  }

  public async getGmbKeywordStats({id, periodStart, periodEnd}: DiagonalGrowthWebsiteDetailProps) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/keyword-stats/?period_start=${periodStart}&period_end=${periodEnd}`, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
    });

    return response.data;
  }

  public async activateGmbCampaignStatus(id) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/activate/`, null, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });
    return response.data;
  }
  public async deactivateGmbCampaignStatus(id) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/gmb/${id}/deactivate/`, null, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });
    return response.data;
  }
  public async activateCampaignStatus(id) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/webiste/${id}/activate/`, null, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });
    return response.data;
  }
  public async deactivateCampaignStatus(id) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/webiste/${id}/deactivate/`, null, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });
    return response.data;
  }
  public async activateDrtStatus(id) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/${id}/activate/`, null, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });
    return response.data;
  }
  public async deactivateDrtStatus(id) {
    const response: any = await this.axios.post(`${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/drt/${id}/deactivate/`, null, {
      headers: {
        Accept: 'application/json',
        Authorization: getAuthorizationHeader(),
      },
      cancelToken: this.cancelToken,
    });
    return response.data;
  }
  public downloadCSVFile(periodStart, periodEnd, url) {
    const token = getTokenFromCookies();
    return `${DiagonalGrowthApi.baseUrl}/star-destroyer/diagonal-growth/${url}?period_start=${periodStart}&period_end=${periodEnd}&export=${true}&jwt=${token}`;
  }
  public async getAvailableDates({id, gridId}) {
    const response: any = await this.axios.get(`${DiagonalGrowthApi.keywordBaseUrl}v2/google-business/${id}/available-dates/?grid_id=${gridId}&super_api_key=${DiagonalGrowthApi.superApiKey}`, {
      headers: {
        Accept: 'application/json',
      },
    });

    return response.data;
  }
}

export const DIAGONAL_GROWTH_API = new DiagonalGrowthApi();
